export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
            <rect opacity="0.01" width="72" height="72" fill="#D8D8D8" />
            <path d="M16 18.4L36.4 34.4L56.8 18.4" stroke="#2164FF" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M58.4008 48C58.4008 49.7673 56.9681 51.2 55.2008 51.2H36.4008H17.6008C15.8335 51.2 14.4008 49.7673 14.4008 48V34.4V20.8C14.4008 19.0327 15.8335 17.6 17.6008 17.6H36.4008H55.2008C56.9681 17.6 58.4008 19.0327 58.4008 20.8V48Z"
                stroke="#03060B"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
